export default "/_next/static/images/product--outbound-fc1f4ae36f12bb97bf6db12e5bac98f7.svg";